import BaseView from './base';
import DesignFacade from '../../../../../facade/design/design';

module.exports = BaseView.extend({
  addElement: function (elementData, target) {
    DesignFacade.create('sticker', Object.assign(
      {
        sticker_id: this.svg.id,
        thumb_src: this.svg.url,
        banner: target && target.parentElement && target.parentElement.dataset.banner
      }, elementData));
  },

  initialize: function (options) {
    this.svg = options.svg;
    BaseView.prototype.initialize.call(this);
    this.setImageListeners();
  },

  setImageListeners: function () {
    this.el.querySelector('img').onload = this.resize;
  },

  getTemplateRenderData: function () {
    return {
      image: { src: this.svg.url }
    };
  }
});
